// extracted by mini-css-extract-plugin
export default {"save_icon":"social-actions-SaveAllAction__save_icon--1EIys"};